import React, { useEffect, useLayoutEffect, useState } from "react";

import { Col, Label, Row } from "reactstrap";
import { getAddress } from "api/AddressApi";


const DeliveryDetails = (props) => {
  const { legend, className, disabled = false, value } = props;
  const [addressData, setAddressData] = useState({});

  useEffect(() => {
    if (value) {
      preloadAddressInfo(value);
    }
  }, [value]);

  const preloadAddressInfo = (addressId) => {
    const addressInformation = getAddress(addressId);
    setAddressData(addressInformation);
  }

  return (
    <div className={className}>
      <h4>{legend}</h4>
      <Row>
        <Col>
          <Label></Label>

        </Col>
      </Row>
    </div>
  );
}

export default DeliveryDetails;